<template>
  <v-dialog
    :value="visible"
    max-width="860"
    width="860"
    content-class="premium-dialog"
    @input="onDialogInput"
  >
    <v-card v-if="pagamento" class="pa-0 dialog-card">
      <v-toolbar flat color="white" dense class="pt-2">
        <v-toolbar-title class="subheading font-weight-bold grey--text text--darken-2">
          REGISTRAR PAGAMENTO
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="close">
          <v-icon color="grey">close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-6 pt-2 pb-5 dialog-body">
        <form v-on:submit.prevent="save">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-center mb-4 mt-2">
              <div class="headline verde--text font-weight-medium">{{ formatCurrency(pagamento.valor) }}</div>
              <div class="subheading grey--text mt-1"><strong>{{ pagamento.descricao }}</strong></div>
            </v-flex>

            <v-flex xs12 class="mb-3">
              <v-layout row wrap class="detalhes-box pa-3">
                <v-flex xs12 sm6 class="mb-2">
                  <div class="caption grey--text">Vencimento</div>
                  <div class="body-2"><strong>{{ formatDate(pagamento.data_vencimento) }}</strong></div>
                </v-flex>
                <v-flex xs12 sm6 class="mb-2 detalhe-direita">
                  <div class="caption grey--text">Status</div>
                  <div class="body-2"><strong>{{ pagamento.status ? pagamento.status.toUpperCase() : '---' }}</strong></div>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12>
               <v-text-field
                 label="Data do Pagamento"
                 v-model="data_pagamento"
                 type="date"
                 required
                 :hint="data_pagamento ? `Data selecionada: ${formatDate(data_pagamento)}` : 'Formato de exibição: dd/mm/aaaa'"
                 persistent-hint
                 class="premium-input"
               ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <div
                class="upload-zone text-xs-center pa-4 mt-3"
                :class="{'has-file': file}"
                @click="$refs.fileInput.click()"
              >
                <input type="file" ref="fileInput" @change="onFileChange" accept="image/*,application/pdf" style="display: none;">

                <template v-if="!file">
                  <v-icon size="32" color="grey lighten-1">cloud_upload</v-icon>
                  <div class="subheading grey--text text--darken-1 mt-2">Anexar Comprovante</div>
                  <div class="caption grey--text lighten-1">* Obrigatório (PDF ou Imagem)</div>
                </template>

                <template v-else>
                  <v-icon size="32" color="green">check_circle_outline</v-icon>
                  <div class="subheading green--text text--darken-1 mt-2 text-truncate" style="max-width: 100%;">
                    {{ fileName }}
                  </div>
                  <v-btn small flat color="red" @click.stop="resetFile" class="mt-1">Trocar arquivo</v-btn>
                </template>
              </div>
            </v-flex>
          </v-layout>
        </form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3 dialog-actions">
        <v-btn flat large color="grey" @click="close" class="font-weight-bold btn-cancelar">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          dark
          large
          class="verde px-4 font-weight-bold btn-acao-principal btn-registrar"
          @click="save"
          :loading="loading"
          :disabled="!file || !data_pagamento || loading"
        >
          <v-icon left>payment</v-icon> Registrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { apiURL } from '@/config'
import moment from 'moment'
import { formatBRDate, formatBRLCurrency } from '@/utils/formatters'

export default {
  props: ['visible', 'pagamento'],
  data () {
    return {
      data_pagamento: moment().format('YYYY-MM-DD'),
      file: null,
      fileName: '',
      loading: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.resetFile()
        this.data_pagamento = moment().format('YYYY-MM-DD')
        this.loading = false
      }
    }
  },
  methods: {
    formatCurrency: formatBRLCurrency,
    formatDate: formatBRDate,
    onFileChange (e) {
      const files = e.target.files
      if (files[0]) {
        this.file = files[0]
        this.fileName = files[0].name
      }
    },
    resetFile () {
      this.file = null
      this.fileName = ''
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    onDialogInput (value) {
      if (value === false && !this.loading) this.close()
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (this.loading) return

      if (this.file && this.data_pagamento) {
        this.loading = true
        this.$store.dispatch('utils/showLoading')

        let formData = new FormData()
        formData.append('acao_pagamento', true)
        formData.append('data_pagamento', this.data_pagamento)
        formData.append('comprovante', this.file)

        axios.post(`${apiURL}/pagamentos/${this.pagamento.id}`, formData).then(() => {
          this.loading = false
          this.$store.dispatch('utils/hideLoading')
          this.$emit('saved')
          this.close()
          this.$store.dispatch('utils/showSnackbar', {
            type: 'success',
            text: 'Pagamento registrado com sucesso!'
          })
        }).catch((error) => {
          this.loading = false
          this.$store.dispatch('utils/hideLoading')
          let text = 'Erro ao registrar pagamento.'
          if (error.response && error.response.data && error.response.data.error) {
            text = error.response.data.error
          }
          this.$store.dispatch('utils/showSnackbar', {
            type: 'error',
            text: text
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.dialog-card {
  width: 100%;
  max-width: none;
}

.dialog-body {
  max-height: 78vh;
  overflow-y: auto;
}

.detalhes-box {
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #fafafa;
}

.btn-acao-principal {
  box-shadow: 0 4px 14px rgba(79, 191, 70, 0.35) !important;
}

.btn-acao-principal.btn--disabled {
  box-shadow: none !important;
}

.upload-zone {
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s ease;
  cursor: pointer;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.upload-zone:hover {
  border-color: #bdbdbd;
  background-color: #f5f5f5;
}
.upload-zone.has-file {
  border-color: #81c784;
  background-color: #f1f8e9;
  border-style: solid;
}

@media (max-width: 599px) {
  .detalhe-direita {
    text-align: left;
  }

  .dialog-actions {
    display: block;
  }

  .dialog-actions .spacer {
    display: none;
  }

  .dialog-actions .btn {
    width: 100%;
    margin: 0 0 8px 0 !important;
  }

  .dialog-actions .btn:last-child {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// PagamentosPagar.vue?66ee4eda